import { InjectionKey } from 'vue';
import { RepositoryFactory, Repositories } from '@/repositories/RepositoryFactory';
import {
  CustomerShareCampaignParsed,
  ShareCampaignGoal,
  ShareCampaignParsed,
  ShareCampaignSettings,
} from '@comsbi/common/src/types/models';

export { ShareCampaignSettings, ShareCampaignParsed, CustomerShareCampaignParsed };

export type CustomerShareCampaign = Omit<CustomerShareCampaignParsed, 'shareCampaign'> & {
  shareCampaign: ShareCampaignParsed;
};

const ShareCampaignRepository = RepositoryFactory.get('shareCampaign') as Repositories['shareCampaign'];

const CHANNEL_ID: string =
  process.env.NODE_ENV === 'local' ? window.CHANNEL_ID || process.env.VUE_APP_CHANNEL_ID : window.CHANNEL_ID;

export const useShareCampaign = () => {
  /**
   * 指定スタンプカードマスターの顧客データを生成取得する
   */
  const resolve = async (shareCampaignId: string): Promise<{ result: CustomerShareCampaign }> => {
    return (await ShareCampaignRepository.resolveCustomerShareCampaign(shareCampaignId)) as any;
  };

  const stamp = async (
    shareCampaignId: string,
    itemKey?: string
  ): Promise<{ result: { customerStamp: CustomerShareCampaign; goal?: ShareCampaignGoal } }> => {
    return (await ShareCampaignRepository.stamp(shareCampaignId, itemKey)) as any;
  };

  return {
    resolve,
    stamp,
  };
};

type ShareCampaignType = ReturnType<typeof useShareCampaign>;
export const ShareCampaignKey: InjectionKey<ShareCampaignType> = Symbol('ShareCampaign');
